__turbopack_context__.v({
  "hasText": "badge-module-scss-module__w0j9XW__hasText",
  "imageBig": "badge-module-scss-module__w0j9XW__imageBig",
  "imageSmall": "badge-module-scss-module__w0j9XW__imageSmall",
  "text": "badge-module-scss-module__w0j9XW__text",
  "wrapper": "badge-module-scss-module__w0j9XW__wrapper",
});
